import { HideContentFromServerRender } from '@components/primitives/HideContentFromServerRender'
import { Text } from '@components/primitives/Text'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'

export const ShowSummaryClickableText = ({
  isOriginal,
  setIsOriginal,
}: {
  isOriginal: boolean
  setIsOriginal: (val: boolean) => void
}) => {
  const trackEligibilityCriteriaOriginal = () => {
    isOriginal
      ? trackEvent(TrackingEvents.SHOW_SUMMARY_ELIGIBILITY_CRITERIA_CLICKED, {
          source: TrackingSources.LISTING,
        })
      : trackEvent(TrackingEvents.SHOW_ORIGINAL_ELIGIBILITY_CRITERIA_CLICKED, {
          source: TrackingSources.LISTING,
        })
    setIsOriginal(!isOriginal)
  }

  return (
    <HideContentFromServerRender>
      <Text
        className='inline text-blue900'
        onClick={trackEligibilityCriteriaOriginal}
        styleName='p-tiny'
        value={'\u00A0' + (isOriginal ? 'show summary' : 'show original')}
      />
    </HideContentFromServerRender>
  )
}
